import React from 'react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
export function PartnerSection() {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    toast.success('Thanks for reaching out! A team member will contact you.');
    (e.target as HTMLFormElement).reset();
  };
  return <section id="partners" className="py-20 lg:py-32 bg-foodCard border-t-4 border-foodMaroon" data-id="element-210" data-mp="1myj6uy0mdecs">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-211" data-mp="1rvrp0ylrpie1">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-212" data-mp="1wv4cnlkgqtho">
          {/* Form (Left side) */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-foodCream border-4 border-foodMaroon p-8 shadow-[-12px_12px_0px_0px_#F6B303] order-2 lg:order-1" data-id="element-213" data-mp="21lukr6k9xag2">
            <h3 className="text-3xl font-extrabold uppercase mb-6" data-id="element-214" data-mp="zzo35fvjeryv">
              Partner With Us
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-215" data-mp="vwrizkqcmnst">
              <div data-id="element-216" data-mp="qyhh6ra4coy8">
                <label className="block text-sm font-bold mb-2" data-id="element-217" data-mp="qxy3jmri4mq0">
                  Organization Name
                </label>
                <input required type="text" className="w-full bg-white border-2 border-foodMaroon p-3 focus:outline-none focus:border-foodOrange" placeholder="Local Food Bank" data-id="element-218" data-mp="m17n2ybsbp42" />
              </div>

              <div className="grid grid-cols-2 gap-4" data-id="element-219" data-mp="19wanm3jybh0d">
                <div data-id="element-220" data-mp="14yin4l58qmkk">
                  <label className="block text-sm font-bold mb-2" data-id="element-221" data-mp="14zahjsn3qe99">
                    Contact Name
                  </label>
                  <input required type="text" className="w-full bg-white border-2 border-foodMaroon p-3 focus:outline-none focus:border-foodOrange" placeholder="John Smith" data-id="element-222" data-mp="22eo9d4s0jcj3" />
                </div>
                <div data-id="element-223" data-mp="3vvbx0xb4f68s">
                  <label className="block text-sm font-bold mb-2" data-id="element-224" data-mp="3vvu3snvet2uy">Email</label>
                  <input required type="email" className="w-full bg-white border-2 border-foodMaroon p-3 focus:outline-none focus:border-foodOrange" placeholder="john@example.com" data-id="element-225" data-mp="3i4fe5y6zy3ex" />
                </div>
              </div>

              <div data-id="element-226" data-mp="3d417ajh4szih">
                <label className="block text-sm font-bold mb-2" data-id="element-227" data-mp="2z6cmtcqz7udy">
                  Partnership Interest
                </label>
                <select required className="w-full bg-white border-2 border-foodMaroon p-3 focus:outline-none focus:border-foodOrange appearance-none rounded-none" data-id="element-228" data-mp="344nw9mdd02vn">
                  <option value="" data-id="element-229" data-mp="12crmah6ub12z">Select an option...</option>
                  <option value="sponsor" data-id="element-230" data-mp="1chriimubmyip">Sponsor</option>
                  <option value="host" data-id="element-231" data-mp="1ci9av8dv4slc">Host an Event</option>
                  <option value="donate" data-id="element-232" data-mp="17jpr9emqrsw5">Donate Goods</option>
                  <option value="volunteer" data-id="element-233" data-mp="17h3kvibl7jfi">Volunteer Group</option>
                  <option value="other" data-id="element-234" data-mp="1lbw872xpy3wn">Other</option>
                </select>
              </div>

              <div data-id="element-235" data-mp="1gi1r879i0319">
                <label className="block text-sm font-bold mb-2" data-id="element-236" data-mp="1ghi8wpfxrcmp">Message</label>
                <textarea required rows={3} className="w-full bg-white border-2 border-foodMaroon p-3 focus:outline-none focus:border-foodOrange resize-none" placeholder="How would you like to collaborate?" data-id="element-237" data-mp="1v6xwjwk671y6"></textarea>
              </div>

              <button type="submit" className="w-full bg-foodMaroon text-foodCream font-bold text-lg py-4 border-2 border-transparent hover:bg-foodOrange hover:border-foodMaroon shadow-[4px_4px_0px_0px_#2A1B14] hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[2px_2px_0px_0px_#2A1B14] transition-all mt-4" data-id="element-238" data-mp="205ratr7a6wze">
                Send Inquiry
              </button>
            </form>
          </motion.div>

          {/* Pitch & Logos (Right side) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2" data-id="element-239" data-mp="laiwteblrkm4">
            <h2 className="text-5xl md:text-6xl font-extrabold uppercase mb-6" data-id="element-240" data-mp="3tpsvsdk749po">
              Stronger <span className="text-foodOrange" data-id="element-241" data-mp="2bddehmix33n">Together.</span>
            </h2>
            <p className="text-xl font-medium mb-10" data-id="element-242" data-mp="2dhrtti1tki6">
              We partner with local nonprofits, farms, and businesses to expand
              our impact. From sourcing fresh ingredients to hosting community
              wellness days, our partners make it possible.
            </p>

            <h4 className="font-bold text-lg mb-4 uppercase tracking-wider text-foodMaroon/60" data-id="element-243" data-mp="2yf4qpaef4ryc">
              Current Community Partners
            </h4>
            <div className="grid grid-cols-2 gap-4" data-id="element-244" data-mp="2oi9repabmnj0">
              {[{
              name: 'San Francisco Recreation & Parks',
              href: 'https://sfrecpark.org/'
            }, {
              name: 'Foodwise',
              href: 'https://foodwise.org/'
            }, {
              name: 'Dragonspunk GRO',
              href: 'https://www.dragonspunk.org/'
            }, {
              name: 'India Basin Waterfront Park',
              href: 'https://ibwaterfrontpark.com/'
            }].map((partner, i) => {
              const content = <span className="font-display font-bold text-foodMaroon/70 text-lg uppercase text-center leading-tight" data-id="element-245" data-mp="1rttrq0dhyxs6">
                    {partner.name}
                  </span>;
              const baseClass = 'bg-foodCream border-2 border-foodMaroon h-24 flex items-center justify-center p-4 transition-all duration-300';
              return partner.href ? <a key={i} href={partner.href} target="_blank" rel="noopener noreferrer" className={`${baseClass} hover:bg-foodGold`} data-id="element-246" data-mp="1d74te1uzeqnd">
                    {content}
                  </a> : <div key={i} className={`${baseClass} grayscale hover:grayscale-0`} data-id="element-247" data-mp="1r5l1nx8hsp7m">
                    {content}
                  </div>;
            })}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}